module.exports = __webpack_public_path__ + "static/media/SX.c70e8d70.svg";